import { render, staticRenderFns } from "./ShowPrice.vue?vue&type=template&id=62c41c06&"
import script from "./ShowPrice.vue?vue&type=script&lang=js&"
export * from "./ShowPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports